export default "__VITE_ASSET__DToZviaR__"